import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useObservable} from '@ngneat/react-rxjs';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import {clientsServicesQuery, clientsServicesService} from '@store/clients/services';

import {Download, GroupAction} from '@icons/index';
import ClientUnitContractedServicesTable
  from '@screens/admin/clients/details/clientUnits/details/contractedServices/ClientUnitContractedServices.table';

const ClientUnitContractedServicesTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [selectedClientsServices] = useObservable(clientsServicesQuery.selectedClientsServices$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsServicesService.getClientsServicesCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} mt="-35px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            startIcon={<GroupAction/>}
            disabled={!selectedClientsServices.length}>
            {t('global.groupedAction')}
          </Button>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>
        </Stack>
      </Stack>
      <ClientUnitContractedServicesTable/>
    </Stack>
  );
};

export default ClientUnitContractedServicesTab;
